import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=cede3150&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=cede3150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cede3150",
  null
  
)

export default component.exports